export default __webpack_public_path__ + "static/media/polkadot-inner.51ddeaaf.svg";